import axios from 'axios'

export const systemTools = {
    namespaced: true,
    state: {
        lists: {},
    },
    getters: {
        lists: function (state) {
            return state.lists;
        }
    },
    actions: {
        lists: function (context) {
            return new Promise((resolve, reject) => {
                axios
                    .get('admin/setting/system')
                    .then((res) => {
                        context.commit('lists', res.data.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        save: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put('admin/setting/system', payload)
                    .then((res) => {
                        context.commit('lists', res.data.data);
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        runCommand: function (context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('admin/setting/system/run-command', payload)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
    mutations: {
        lists: function (state, payload) {
            state.lists = payload;
        }
    },
}
